import {isEmpty} from 'lodash/fp'

/** 오브젝트 배열의 아이템의 특정 키값과 일치하는 경우 목록 가장 앞으로 정렬 */
export const shiftToFirstBy =
    <I extends {[key in keyof I]: unknown}>(key: keyof I, val: unknown) =>
    (list: I[]) => {
        const index = list.findIndex((item) => item[key] === val)
        return isEmpty(val) || index < 0
            ? list
            : [...(list[index] ? [list[index]] : []), ...list.slice(0, index), ...list.slice(index + 1)]
    }

/** 오브젝트 배열의 아이템의 특정 키값과 일치하는 객체가 존재하는지 여부 */
export const checkObjectWithKeyword = <I extends {[key in keyof I]: unknown}>(
    array: Array<I>,
    property: keyof I,
    keyword: string,
): boolean => {
    return array.some((item) => item[property] === keyword)
}
